import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import LocationFeatureForm from './LocationFeatureForm'

const LocationFeatureCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <LocationFeatureForm />
      </Create>
    </SectionWrapper>
  )
}

export default LocationFeatureCreate
